<div class="mt-5 mb-5 d-flex flex-column align-items-center justify-content-center">
  <!-- <mat-icon [svgIcon]="icon"></mat-icon> -->
  <app-img [config]="profilePhotoConfig"></app-img>
  <h6 class="mt-3">{{title}}</h6>
  <p class="text-center">{{subtitle}}</p>
  <button *ngIf="button" (click)="btnClicked()" class="x-btn x-btn-primary mt-4 w-100">Add recipient</button>
</div>
